/* eslint-disable no-unused-vars */
export enum TextModes {
  TEXT_AND_MEDIA = 'text-and-media',
  TEXT_NOT_VISIBLE = 'text-hidden',
  MEDIA_NOT_VISIBLE = 'media-hidden',
}
